module.exports = __webpack_public_path__ + "static/media/DJDJEntertainment.b7ab1399.png";